import React from 'react';
import '@higherlogic/ocfe/styles/main';
import theme from '@higherlogic/ocfe/styles/sass-variables.scss';
import { ThemeProvider } from 'styled-components';

const GlobalThemeProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
    return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
};

export default GlobalThemeProvider;
